import React from 'react';

interface IProps {
  percent: number;
  children: React.ReactNode;
  large?: boolean;
  dark?: boolean;
}

export default function ProgressRing(props: IProps) {
  const className = [
    'members-analytics-ring',
    props.large ? 'members-analytics-ring-large' : '',
    props.dark ? 'members-analytics-ring-dark' : '',
  ].filter(Boolean).join(' ');

  return (
    <div
      className={className}
      style={{ '--members-analytics-ring-percent': `${props.percent}%` } as React.CSSProperties}>
      <span>{props.children}</span>
    </div>
  );
}
